import { Culture } from '../../types';

export const lakota: Culture = {
  name: 'Lakota',
  languageFamily: 'Siouan',
  terms: [
    {
      word: 'Čhaŋté',
      phonetic: 'chahn-teh',
      description: 'Lakota word for "heart" or "compassion."'
    },
    {
      word: 'Čhaŋté Wašté',
      phonetic: 'chahn-teh wah-sh-tay',
      description: 'Lakota phrase meaning "good heart."'
    },
    {
      word: 'Háu',
      phonetic: 'how',
      description: 'Traditional Lakota greeting used mainly by men.'
    },
    {
      word: 'Mitákuye Oyás\'iŋ',
      phonetic: 'mee-tah-kway oh-yah-seen',
      description: 'Lakota phrase meaning "we are all related."'
    },
    {
      word: 'Oyáte',
      phonetic: 'oh-yah-tay',
      description: 'Lakota word for "people" or "nation."'
    },
    {
      word: 'Táku',
      phonetic: 'tah-koo',
      description: 'Lakota word meaning "something" or "what."'
    },
    {
      word: 'Wakan Tanka',
      phonetic: 'wah-kahn tahn-kah',
      description: 'Lakota phrase meaning "Great Spirit" or "Great Mystery."'
    },
    {
      word: 'Wašíču',
      phonetic: 'wah-shee-choo',
      description: 'Lakota term for "non-Native" or "white person," historically used to describe settlers.'
    },
    {
      word: 'Wóyute',
      phonetic: 'woh-yoo-teh',
      description: 'Lakota word meaning "food" or "meal."'
    }
  ]
};